import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { auth } from '../firebaseconfig';
import '../views/styles/TopNav.css';
import logoImage from '../assets/sbLogo.png'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSignInAlt, faCamera, faHistory, faSignOutAlt, faBars, faHome } from '@fortawesome/free-solid-svg-icons';

const TopNav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const user = auth.currentUser;

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/'); // Redirect to home after logout
    } catch (error) {
      console.error("Logout Error:", error);
    }
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="top-nav">
      <div className="logo-container">
        <Link to="/">
          <img src={logoImage} alt="Logo" className="logo-image" />
        </Link>
        <span className="app-name">SafeByte</span>
        <button className="hamburger" onClick={toggleMenu}>
          <FontAwesomeIcon icon={faBars} />
          <span className="menu-text">Menu</span>
        </button>
      </div>
      <ul className={`nav-list ${menuOpen ? 'show' : ''}`}>
        <li className={location.pathname === '/' ? 'active' : ''}>
          <Link to="/">
            <FontAwesomeIcon icon={faHome} /> Hjem
          </Link>
        </li>
        <li className={location.pathname === '/profile' ? 'active' : ''}>
          <Link to="/profile">
            <FontAwesomeIcon icon={faUser} /> Min Profil
          </Link>
        </li>
        <li className={location.pathname === '/scan' ? 'active' : ''}>
          <Link to="/scan">
            <FontAwesomeIcon icon={faCamera} /> Scan Produkt
          </Link>
        </li>
        <li className={location.pathname === '/results' ? 'active' : ''}>
          <Link to="/results">
            <FontAwesomeIcon icon={faHistory} /> Historik
          </Link>
        </li>
        {user ? (
          <li>
            <button onClick={handleLogout} className="logout-button">
              <FontAwesomeIcon icon={faSignOutAlt} /> Logout
            </button>
          </li>
        ) : (
          <li className={location.pathname === '/login' ? 'active' : ''}>
            <Link to="/login">
              <FontAwesomeIcon icon={faSignInAlt} /> Login
            </Link>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default TopNav;
